import React from 'react';

import './index.css';

const IconEdit = (props) => {

  return (
    <svg {...props} className={`icon-edit ${props.className ? props.className : ''}`} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.7925 0L17 3.20755L14.8005 5.40701L11.593 2.19946L13.7925 0Z" fill="#6F9AA6"/>
      <path d="M10.4933 3.29919L13.7008 6.50674L4.90297 15.3046L1.69542 12.097L10.4933 3.29919Z" fill="#6F9AA6"/>
      <path d="M0 17L3.80323 16.4043L0.595687 13.1968L0 17Z" fill="#6F9AA6"/>
    </svg>
  );
}

export default IconEdit;